import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES, SCENARIOS, QUIZZES } from "../../utils/constants";
import { getScenarioNumByPath, getTimer, updateStats } from "../../utils/helpers";
import { updateTime } from "../../redux/actions";
import { postAnswer } from "../../api/answer";
import {
  modalConfirm,
  modalQuestionResolution,
  modalQuestionExplanation,
  modalHint,
  modalHintShow
} from "../../utils/logger";
import { IconProgressHelp, IconHandClick } from "@tabler/icons-react";
import CheckButton from "../../components/CheckButton";
import estasseguro from "../../assets/bg/estasseguro-avatar-green.png";
import respuestacorrecta from "../../assets/bg/correcto-avatar.png";
import respuestaincorrecta from "../../assets/bg/incorrecto-avatar.png";
import btnPistaGreen from "../../assets/btnPistaGreen.png"
import imageHint from "../../assets/hints/imageHintGreen.png"
import imageHintUsed from "../../assets/btnPistaGreen.png"
import imgPista from "../../assets/hints/hint-scenario5-test2.jpg"

function Scenario5Impacto({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const group = useSelector((state) => state.group);

  const activeScenario = getScenarioNumByPath(location.pathname);

  const QUIZ_ID = QUIZZES.IMPACTO_SUPERVIVENCIA;
  const SCENARIO_ID = SCENARIOS.SCENARIO_5;

  const [selectedOption, setSelectedOption] = useState(null);
  const [isCompleted, setIsCompleted] = useState(false);
  const [hintUsed, setHintUsed] = useState(false);
  const [hintPenalty, setHintPenalty] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const NUMBERATTEMPTS = 1;
  const CORRECT_ANSWER_POINTS = 10;
  const WRONG_ANSWER_POINTS = -5;

  const options = [
    {
      id: 1,
      text: "Sí",
      correct: false,
      explanation: "-----"
    },
    {
      id: 2,
      text: "No",
      correct: true,
      explanation: "-----"
    },
  ];

  async function submitAnswer(deltaPoints, correct) {
    const totalTime = getTimer();
    dispatch(updateTime(totalTime, 1));

    const newScore = (group?.score || 0) + deltaPoints;

    try {
      const res = await postAnswer({
        scenario: SCENARIO_ID,
        quiz: QUIZ_ID,
        group: group?._id,
        score: deltaPoints,
        time: totalTime,
        lastVisited: ROUTES.SCENARIO5_CONCLUSION,
        correct
      });

      if (res.status === 201) {
        setIsCompleted(true);

        // Seguimos el flujo normal
        navigate(ROUTES.SCENARIO5_CONCLUSION);
      }
    } catch (error) {
      const status = error?.response?.status;
      const code = error?.response?.data?.code;

      if (status === 409 && code === "E_DUPLICATE_ANSWER") {
        // Modal elegante avisando que ya estaba respondida
        await modalQuestionResolution({
          correct: false, // o false; aquí solo uso el modal para informar
          question: "Respuesta ya registrada",
          textHtml: `<div class="txt32 txtBlue bold">Esta pregunta ya se había contestado con anterioridad y no se contabilizará, pueden continuar con el resto del juego.</div>`,
          customConfirmButtonHtml: "Ir a la conclusión",
        });

        navigate(ROUTES.SCENARIO5_CONCLUSION);
        return;
      }

      // Cualquier otro error
      await modalQuestionResolution({
        correct: false,
        question: "No se pudo guardar",
        textHtml: `<div class="txt24 txt-red bold">Ha ocurrido un problema al registrar tu respuesta. Inténtalo de nuevo</div>`,
        customConfirmButtonHtml: "Aceptar",
      });

      setIsSubmitting(false);
    }
  }
        
  const useHint = async () => {
    // Tu contenido de pista: texto/HTML o URL de imagen
    const hint = `<img src=${imgPista} alt="Pista" style="width:100%;" />`;

    if (hintUsed) {
      // Si ya se usó, abre la pista directamente (sin confirmar)
      await modalHintShow({ hint, imageHintUsed, color: "green", big: true });
      return;
    }

    // Primera vez: confirmar, mostrar pista y aplicar penalización
    const { used } = await modalHint({ image: imageHint, imageHintUsed, hint, color: "green", big: true });
    if (used && !hintUsed) {
      setHintUsed(true);
      setHintPenalty(3); // restaremos 3 puntos al enviar la respuesta
    }
  };

  function checkAnswer() {
    if (!selectedOption) {
      modalQuestionResolution({
        correct: false,
        textHtml: `<img src=${estasseguro} alt="Debe seleccionar una opción" class="estasseguro" /><div class="text-center txtTitulos mt-3 green">Debe seleccionar una opción</div>`,
      });
      return;
    }

    const option = options.find((o) => o.id === selectedOption);

    modalConfirm({ estasseguro, color : "green" }).then((res) => {
      if (res.isConfirmed) {
        setIsSubmitting(true);
        if (option.correct) {
		      const deltaPoints = CORRECT_ANSWER_POINTS - hintPenalty;
          modalQuestionResolution({
            correct: true,
            question: option.text,
            //answerHtml: `<p>${option.explanation}</p>`,
            textHtml: `<img src=${respuestacorrecta} alt="Respuesta correcta" style='max-width:420px' /><div class="txt32 bold pt-4">Ganaron ${deltaPoints} puntos con esta respuesta</div>`,
            customConfirmButtonHtml: "Continuar",
          }).then(() => {
            submitAnswer(deltaPoints, option.correct);
          });
        } else {
		      const deltaPoints = WRONG_ANSWER_POINTS - hintPenalty;
          modalQuestionResolution({
            correct: false,
            question: option.text,
            //answerHtml: `<p>${option.explanation}</p>`,
            textHtml: `<img src=${respuestaincorrecta} alt="Respuesta incorrecta" style='max-width:420px' /><div class="txt32 bold pt-4">Perdieron ${deltaPoints} puntos con esta respuesta</div>`,
            customConfirmButtonHtml: "Continuar",
          }).then(() => {
			      submitAnswer(deltaPoints, option.correct);
          });
        }
      }
    });
  }

  return (
    <div className="h-100">
		<div className="container-fluid px-5 h-100 d-flex flex-column justify-content-center bgCircleGreen2">
        <h5 className="mb-2">Aunque Juan es un paciente joven de 52 años, si hubiera sido un paciente anciano o frágil (p. ej., 82 años con índice de fragilidad),</h5>
        <div className="notaCasoClinicoAutor">caso clínico del autor</div>
        <h3 className="txt24 txt-white text-center" style={{ backgroundColor: "#53CE76", borderRadius: "10px", padding: "20px"}}>
         ¿estaría absolutamente contraindicado darle anticuerpos biespecíficos?
        </h3>
        <div className="d-flex justify-content-between">
          <h5 className="mb-4 txt24 text-left my-2 gray">
            <IconHandClick size={40} color="#757575" stroke={1} /> Seleccionen la respuesta correcta
          </h5>
        </div>
		
        <div className="row g-4">
          {options.map((option) => (
            <div key={option.id} className="col-md-4 offset-md-1 mt-5">
              <div
                className={`cursor-pointer p-3 rounded shadow h-100 ${
                  selectedOption === option.id ? "selected" : ""
                }`}
                style={{
                  border:
                    selectedOption === option.id
                      ? "1px solid #53CE7655"
                      : "1px solid #fff",
                  backgroundColor:
                    selectedOption === option.id
                      ? "#53CE7655"
                      : "#fff",
                }}
                onClick={() => setSelectedOption(option.id)}
              >
                <div className="txt30 text-center txtSemiBlack bold">{option.text}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-between mt-5">
          <div className="position-relative d-inline-block">
            <img
              src={btnPistaGreen}
              className={`btnPista mt-2 ${hintUsed ? "used" : ""}`}
              onClick={useHint}
              alt={hintUsed ? "Pista usada" : "Usar pista"}
              title={hintUsed ? "Pista usada (-3)" : "Usar pista (-3 puntos)"}
            />
            {hintUsed && <span className="badge-penalty">-3</span>}
          </div>
          <CheckButton
            text="Comprobar respuesta"
            onClick={checkAnswer}
            disabled={isCompleted || isSubmitting}
            color="green"
            loading={isSubmitting}
          />
        </div>
      </div>

      <ScenarioBar activeScenario={activeScenario} />
    </div>
  );
}

export default injectIntl(Scenario5Impacto);
